import { render, staticRenderFns } from "./NotificationMenu.vue?vue&type=template&id=c37b115a&"
import script from "./NotificationMenu.vue?vue&type=script&lang=js&"
export * from "./NotificationMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports